import * as React from 'react';

const WarningIcon = ({fillColor = '#2d2756', width = 18, height = 18}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18">
    <path
      fill={fillColor}
      d="M9.067 13.166a.61.61 0 0 0 .621-.625v-3.75a.603.603 0 0 0-.18-.445.61.61 0 0 0-.448-.18.61.61 0 0 0-.621.625v3.75c0 .177.06.325.18.445.121.12.27.18.448.18Zm-.066-6.542a.677.677 0 0 0 .49-.191.635.635 0 0 0 .198-.475c0-.201-.066-.37-.198-.505a.655.655 0 0 0-.49-.204.656.656 0 0 0-.49.204.696.696 0 0 0-.197.505c0 .189.066.347.197.475a.676.676 0 0 0 .49.191Zm.006 10.709a8.066 8.066 0 0 1-3.24-.657 8.468 8.468 0 0 1-2.651-1.791 8.464 8.464 0 0 1-1.792-2.653 8.081 8.081 0 0 1-.656-3.243c0-1.15.219-2.231.656-3.243a8.338 8.338 0 0 1 1.792-2.642 8.553 8.553 0 0 1 2.653-1.782A8.082 8.082 0 0 1 9.012.666c1.15 0 2.23.219 3.243.656a8.425 8.425 0 0 1 2.642 1.782 8.416 8.416 0 0 1 1.781 2.645 8.1 8.1 0 0 1 .657 3.245c0 1.149-.22 2.229-.657 3.24a8.512 8.512 0 0 1-1.78 2.647 8.413 8.413 0 0 1-2.647 1.792 8.06 8.06 0 0 1-3.244.66Zm.005-1.25c1.965 0 3.635-.691 5.01-2.073 1.375-1.382 2.063-3.056 2.063-5.021 0-1.965-.687-3.635-2.059-5.01S10.98 1.916 9.001 1.916c-1.958 0-3.628.686-5.01 2.059-1.382 1.372-2.073 3.047-2.073 5.024 0 1.959.69 3.629 2.073 5.01 1.382 1.383 3.055 2.074 5.02 2.074Z"
    />
  </svg>
);

export default WarningIcon;
